import {BaseURL} from ".";
import {getOptional} from "../../common/fetch";
import {Voucher, VouchersApi} from "../domain/vouchers";

export default class CDSVouchersApi implements VouchersApi {
  async getVoucherByCode(code: string): Promise<Voucher | null> {
    return getOptional<Voucher | null>(`${BaseURL}/api/vouchers/${code}`);
  }
}
